// components/CurrencySwitcher.js
import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';

const CurrencySwitcher = () => {
  const { currency, setCurrency, getCurrencySymbol } = useCurrency();

  return (
    <div className="currency-switcher">
      <select 
        value={currency} 
        onChange={(e) => setCurrency(e.target.value)}
        className="currency-select"
      >
        <option value="THB">THB ฿</option>
        <option value="USD">USD $</option>
        <option value="EUR">EUR €</option>
      </select>
    </div>
  );
};

export default CurrencySwitcher;